import { useEffect, useState } from 'react';
import packageJson from '../../package.json';

export function useAppDisplayVersion(): string {
  const [version, setVersion] = useState(packageJson.version);

  useEffect(() => {
    const getAppVersion = (
      window as { electron?: { getAppVersion?: () => Promise<string> } }
    ).electron?.getAppVersion;
    if (!getAppVersion) return;
    void getAppVersion().then((nativeVersion) => {
      if (nativeVersion) setVersion(nativeVersion);
    });
  }, []);

  return version;
}
